// @flow
import * as React from 'react'

type PopupContainerProps = {
  children: React.Node,
}

function PopupContainer({ children }: PopupContainerProps): React.Node {
  return (
    <div
      aria-labelledby="user-menu"
      aria-orientation="horizontal"
      className="bg-blue-50 flex px-2 shadow-xs"
      role="menu"
      style={{ overflow: 'hidden', borderRadius: '0.25rem' }}
    >
      {children}
    </div>
  )
}

type IconButtonProps = {
  IconComponent: React.ComponentType<{ size: number }>,
  children: React.Node,
  minWidth?: number,
  onClick: (SyntheticEvent<HTMLButtonElement>) => void | Promise<void>,
  style?: {| paddingTop?: string |},
}

function IconButton({
  IconComponent,
  children,
  minWidth,
  onClick,
  style = {},
}: IconButtonProps): React.Node {
  return (
    <button
      className="max-w-xs flex flex-col items-center hover:bg-blue-100 focus:outline-none transition duration-150 ease-in-out"
      onClick={onClick}
      style={{
        minWidth: minWidth || 'initial',
        paddingBottom: '.5rem',
        paddingLeft: '.5rem',
        paddingRight: '.5rem',
        paddingTop: '.5rem',
        ...style,
      }}
    >
      <IconComponent size={4} />
      <span className="text-xs text-txt-emphasis">{children}</span>
    </button>
  )
}

const BuilderPopupFragment = {
  PopupContainer,
  IconButton,
}

export default BuilderPopupFragment
